var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Impuesto " + _vm._s(_vm.form.descripcion))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout__controls" },
        [
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.permiteEditarImpuesto || _vm.permiteEliminarImpuesto,
                  expression:
                    "(permiteEditarImpuesto || permiteEliminarImpuesto)"
                }
              ],
              staticClass: "btn-info btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.consultarTarifas }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _vm._v(" "),
              _c("span", [_vm._v("Buscar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                width: "80%",
                height: "auto",
                name: "listaImpuestos",
                scrollable: ""
              }
            },
            [
              _c("lista-impuestos", {
                attrs: {
                  createButton: false,
                  editButton: false,
                  deleteButton: false
                },
                on: { selected: _vm.selectedTarifa }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layout__main" }, [
      _c("div", { staticClass: "layout__main-form" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-field select2",
                    class: { "select2--disabled": _vm.estado !== "N" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            label: "nombre",
                            id: "impuesto",
                            placeholder: "Seleccione...",
                            options: _vm.impuestos
                          },
                          model: {
                            value: _vm.selectedImpuesto,
                            callback: function($$v) {
                              _vm.selectedImpuesto = $$v
                            },
                            expression: "selectedImpuesto"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "impuesto" } }, [
                          _vm._v("Impuesto")
                        ]),
                        _vm._v(" "),
                        _vm.errores.id_impuesto
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.id_impuesto[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          readonly: _vm.estado !== "N",
                          id: "descripcion",
                          placeholder: "###"
                        },
                        model: {
                          value: _vm.form.descripcion,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "descripcion", $$v)
                          },
                          expression: "form.descripcion"
                        }
                      },
                      [
                        _c("span", [_vm._v("Descripción")]),
                        _vm._v(" "),
                        _vm.errores.descripcion
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.descripcion[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "porcentaje",
                          placeholder: "##.## %",
                          vMoney: "",
                          format: _vm.porcentaje
                        },
                        model: {
                          value: _vm.form.porcentaje,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "porcentaje", $$v)
                          },
                          expression: "form.porcentaje"
                        }
                      },
                      [
                        _c("span", [_vm._v("Porcentaje %")]),
                        _vm._v(" "),
                        _vm.errores.porcentaje
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.porcentaje[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          readonly: !_vm.esIce,
                          id: "numero_unidades",
                          placeholder: "##.##",
                          vMoney: "",
                          format: _vm.decimal
                        },
                        model: {
                          value: _vm.form.numero_unidades,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "numero_unidades", $$v)
                          },
                          expression: "form.numero_unidades"
                        }
                      },
                      [
                        _c("span", [_vm._v("# Unidades")]),
                        _vm._v(" "),
                        _vm.errores.numero_unidades
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.numero_unidades[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          readonly: _vm.estado !== "N",
                          id: "id_tarifa",
                          placeholder: "###"
                        },
                        model: {
                          value: _vm.form.id_tarifa,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "id_tarifa", $$v)
                          },
                          expression: "form.id_tarifa"
                        }
                      },
                      [
                        _c("span", [_vm._v("Cod. Tarifa")]),
                        _vm._v(" "),
                        _vm.errores.id_tarifa
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.id_tarifa[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          readonly: !_vm.esIce,
                          vMoney: "",
                          format: _vm.money,
                          id: "tarifa_especifica",
                          placeholder: "$ ##.##"
                        },
                        model: {
                          value: _vm.form.tarifa_especifica,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "tarifa_especifica", $$v)
                          },
                          expression: "form.tarifa_especifica"
                        }
                      },
                      [
                        _c("span", [_vm._v("Tarifa específica")]),
                        _vm._v(" "),
                        _vm.errores.tarifa_especifica
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.tarifa_especifica[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          readonly: !_vm.esIce,
                          vMoney: "",
                          format: _vm.money,
                          id: "tarifa_ed_valorem",
                          placeholder: "$ ##.##"
                        },
                        model: {
                          value: _vm.form.tarifa_ed_valorem,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "tarifa_ed_valorem", $$v)
                          },
                          expression: "form.tarifa_ed_valorem"
                        }
                      },
                      [
                        _c("span", [_vm._v("Tarifa ed valorem")]),
                        _vm._v(" "),
                        _vm.errores.tarifa_ed_valorem
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.tarifa_ed_valorem[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.selectedImpuesto !== null &&
                          _vm.selectedImpuesto.es_retenible === "S",
                        expression:
                          "selectedImpuesto !== null && selectedImpuesto.es_retenible === 'S'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c("p", [
                      _c("label", { attrs: { for: "aplicaRetencion" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.aplica_retencion,
                              expression: "form.aplica_retencion"
                            }
                          ],
                          attrs: { type: "checkbox", id: "aplicaRetencion" },
                          domProps: {
                            checked: Array.isArray(_vm.form.aplica_retencion)
                              ? _vm._i(_vm.form.aplica_retencion, null) > -1
                              : _vm.form.aplica_retencion
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.form.aplica_retencion,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form,
                                      "aplica_retencion",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form,
                                      "aplica_retencion",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form, "aplica_retencion", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Aplica retención")])
                      ])
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.id_impuesto == "1",
                      expression: "form.id_impuesto == '1'"
                    }
                  ],
                  staticClass: "col-xs-12 col-md-6"
                },
                [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("date-picker", {
                          attrs: {
                            type: "date",
                            format: "dd-MM-yyyy",
                            id: "fecha",
                            lang: "es",
                            disabled: _vm.estado != "N"
                          },
                          model: {
                            value: _vm.form.fecha_habilitacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_habilitacion", $$v)
                            },
                            expression: "form.fecha_habilitacion"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Fecha desde que aplica")]),
                        _vm._v(" "),
                        _vm.errores.fecha_habilitacion
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.errores.fecha_habilitacion[0])
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main-buttons" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.permiteCrearImpuesto && _vm.estado === "N") ||
                      (_vm.permiteEditarImpuesto && _vm.estado !== "N"),
                    expression:
                      "(permiteCrearImpuesto && estado === 'N') || (permiteEditarImpuesto && estado !== 'N')"
                  }
                ],
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.guardarTarifa }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _vm._v(" "),
                _c("span", [_vm._v("Guardar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.permiteCrearImpuesto,
                    expression: "permiteCrearImpuesto"
                  }
                ],
                staticClass: "btn-light btn--text",
                attrs: { type: "button" },
                on: { click: _vm.nuevoImpuesto }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" "),
                _c("span", [_vm._v("Nuevo")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "A" && _vm.permiteEliminarImpuesto,
                    expression: "estado === 'A' && permiteEliminarImpuesto"
                  }
                ],
                staticClass: "btn-danger btn--text",
                attrs: { type: "button" },
                on: { click: _vm.eliminarImpuesto }
              },
              [
                _c("i", { staticClass: "fa fa-ban" }),
                _vm._v(" "),
                _c("span", [_vm._v("Eliminar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "I" && _vm.permiteEliminarImpuesto,
                    expression: "estado === 'I' && permiteEliminarImpuesto"
                  }
                ],
                staticClass: "btn-secondary btn--text",
                attrs: { type: "button" },
                on: { click: _vm.eliminarImpuesto }
              },
              [
                _c("i", { staticClass: "fa fa-power-off" }),
                _vm._v(" "),
                _c("span", [_vm._v("Re-activar")])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información del impuesto")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74c7e900", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74c7e900","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/impuestos/Impuesto.vue
// module id = 520
// module chunks = 0